import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance, { serverURL } from "../../services/FetchNodeServices";

const AllDieses = () => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/v1/mainCategory/get-all-mainCategories"
        );
        if (response) {
          setCategories(response.data?.reverse());
        }
      } catch (error) {
        toast.error("Error fetching categories");
        console.error("Error fetching categories:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmDelete.isConfirmed) {
      try {
        const data = await axiosInstance.delete(
          `/api/v1/mainCategory/delete-mainCategory/${id}`
        );
        if (data.status === 200) {
          setCategories(categories.filter((category) => category._id !== id));
          Swal.fire("Deleted!", "Your category has been deleted.", "success");
        }
      } catch (error) {
        Swal.fire("Error!", "There was an error deleting the category.", "error");
        console.error("Error deleting category:", error);
      }
    }
  };

  const handleCheckboxChange = async (e, categoryId) => {
    const updatedStatus = e.target.checked;
    try {
      const response = await axiosInstance.post(
        `/api/v1/mainCategory/update-main-category-status/${categoryId}`,
        { isHome: updatedStatus }
      );
      if (response.status === 200) {
        setCategories(categories.map((category) =>
          category._id === categoryId
            ? { ...category, isHome: updatedStatus }
            : category
        ));
      }
    } catch (error) {
      toast.error("Error updating category status");
      console.error("Error updating category status:", error);
    }
  };

  // ── NEW: Active / Inactive toggle ───────────────────────────
  const handleActiveToggle = async (categoryId, currentStatus) => {
    const newStatus = !currentStatus;
    try {
      const response = await axiosInstance.post(
        `/api/v1/mainCategory/update-main-category-active/${categoryId}`,
        { isActive: newStatus }
      );
      if (response.status === 200) {
        setCategories(categories.map((category) =>
          category._id === categoryId
            ? { ...category, isActive: newStatus }
            : category
        ));
        toast.success(`Category ${newStatus ? "activated" : "deactivated"} successfully`);
      }
    } catch (error) {
      toast.error("Error updating active status");
      console.error("Error updating active status:", error);
    }
  };

  if (isLoading) return <p>Loading categories...</p>;

  return (
    <>
      <ToastContainer />
      <div className="bread">
        <div className="head">
          <h4>All Main Category</h4>
        </div>
        <div className="links">
          <Link to="/add-maincategory" className="add-new">
            Add New <i className="fa-solid fa-plus"></i>
          </Link>
          <Link
            to="/add-mutiple-maincategory-txt"
            className="add-new"
            style={{ marginLeft: "10px" }}
          >
            Add Multiple Categories <i className="fa-solid fa-plus"></i>
          </Link>
        </div>
      </div>

      <section className="main-table">
        <table className="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Name</th>
              <th scope="col">Image</th>
              <th scope="col">Show in Home</th>
              <th scope="col">Status</th>  {/* ← NEW column */}
              <th scope="col">Edit</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            {categories?.length > 0 ? (
              categories.map((category, index) => (
                <tr key={category._id}>
                  <th scope="row">{index + 1}</th>
                  <td>{category?.Parent_name}</td>
                  <td>
                    <img
                      src={`${serverURL}/public/image/${category?.Image}`}
                      alt={category?.Parent_name}
                      style={{ width: "50px", height: "50px" }}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={category?.isHome}
                      onChange={(e) => handleCheckboxChange(e, category._id)}
                    />
                  </td>

                  {/* ── NEW: Active / Inactive toggle button ── */}
                  <td>
                    <button
                      onClick={() => handleActiveToggle(category._id, category.isActive)}
                      className={`bt ${category.isActive ? "delete" : "edit"}`}
                      style={{ minWidth: "90px" }}
                    >
                      {category.isActive ? (
                        <> Active <i className="fa-solid fa-toggle-on"></i> </>
                      ) : (
                        <> Inactive <i className="fa-solid fa-toggle-off"></i> </>
                      )}
                    </button>
                  </td>

                  <td>
                    <Link
                      to={`/edit-maincategory/${category?._id}`}
                      className="bt edit"
                    >
                      Edit <i className="fa-solid fa-pen-to-square"></i>
                    </Link>
                  </td>
                  <td>
                    <button
                      className="bt delete"
                      onClick={() => handleDelete(category._id)}
                    >
                      Delete <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No categories found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
    </>
  );
};

export default AllDieses;